import * as React from 'react';
import useUsers from '../../users/hooks/useUsers';
import { Subscription } from '../types/subscriptions';
import useLicenses from './useLicenses';
const useSubscriptions: () => { subscriptions: Subscription[]; isLoading: boolean } = () => {
  const { licenses, isLoading: licenseIsLoading } = useLicenses();
  const { users, isLoading: userIsLoading } = useUsers();

  const subscriptions = React.useMemo<Subscription[]>(() => {
    if (licenseIsLoading || userIsLoading) {
      return [];
    }
    return licenses.map((license) => {
      return {
        ...license,
        user: (license.assigned_to && users.find((user) => user.id === license.assigned_to)) || undefined,
      };
    });
  }, [licenses, users, licenseIsLoading, userIsLoading]);

  return {
    subscriptions,
    isLoading: licenseIsLoading || userIsLoading,
  };
};

export default useSubscriptions;
